export const BUYER = 'buyer';
export const SELLER = 'seller';
export const FULFILLERS = 'fulfillers';
export const MERCHANTS = 'merchants';
